import { useEffect } from 'react';
import AdminSTGSvg from '../assets/Admin_STG.svg?url';
import AdminPreSvg from '../assets/Admin_Pre.svg?url';
import ClientSTGSvg from '../assets/Client_STG.svg?url';
import ClientPreSvg from '../assets/Client_Pre.svg?url';

export const useFavicon = (type: 'admin' | 'client') => {
  useEffect(() => {
    const env = import.meta.env.REACT_APP_ENV || 'staging'; // 환경변수

    const favicon = document.querySelector(`link[rel='icon']`) as HTMLLinkElement;

    if (favicon && env !== 'production') {
      if (type === 'admin') {
        if (env == 'pre-release') {
          favicon.href = AdminPreSvg;
        } else {
          favicon.href = AdminSTGSvg;
        }
      } else if (type === 'client') {
        if (env == 'pre-release') {
          favicon.href = ClientPreSvg;
        } else {
          favicon.href = ClientSTGSvg;
        }
      }
    }
  }, [type]);
};
